import React from "react";
import {
  Toolbar,
  SaveButton,
  Link,
  Button,
  DisabledInput,
  Edit,
  Create,
  SimpleForm,
  AutocompleteInput,
  SelectInput,
  FormDataConsumer
} from "react-admin";
import { parse } from "query-string";
import dataProviderFactory from "../dataProvider";
import { GET_LIST } from "react-admin";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

class AsyncComponent extends React.Component {
  constructor(props) {
    super(props);
    this.offset = 0;
    this.state = { data: [] };
  }

  async getDataFor(
    itemType,
    locationID1,
    locationID2,
    transferDate,
    setupDate
  ) {
    let data = [];
    if (itemType) {
      if (itemType === "" || !itemType) {
        itemType = "gps_device";
      }
      const dataProvider = await dataProviderFactory("rest");
      let itemStatus = "1";
      let sortField = "id";
      let orderBY = "DESC";
      if (itemType === "vehicle") {
        itemStatus = "A";
      }

      if (itemType === "gps_device") {
        sortField = "model";
        orderBY = "ASC";
        itemStatus = "A";
      }

      // if (itemType === "seat") {
      //   sortField = "model";
      //   orderBY = "ASC";
      //   itemStatus = 1;
      // }

      // if (itemType === "tankbag") {
      //   sortField = "model";
      //   orderBY = "ASC";
      //   itemStatus = true;
      // }

      // if (itemType === "glove") {
      //   sortField = "model";
      //   orderBY = "ASC";
      //   itemStatus = 1;
      // }

      // if (itemType === "helmet") {
      //   sortField = "model";
      //   orderBY = "ASC";
      //   itemStatus = 1;
      // }

      // if (itemType === "jacket") {
      //   sortField = "model";
      //   orderBY = "ASC";
      //   itemStatus = 1;
      // }

      const response = await dataProvider(GET_LIST, itemType + "s", {
        filter: {
          from: "",
          to: "",
          status: itemStatus,
          location_id_1: locationID1,
          location_id_2: locationID2,
          date_1: transferDate,
          date_2: setupDate,
          transfer_availability: "true"
        },
        pagination: {
          page: 1,
          perPage: 999
        },
        sort: { field: sortField, order: orderBY }
      });
      response.data.map(function(item) {
        if (itemType !== "vehicle") {
          return data.push({ id: item.id, description: item.model });
        } else {
          return data.push({
            id: item.id,
            description: `${item.model_name} - ${item.licence_plate} ${item.renting ? "®" : ""} - ${item.color} - ${item.vehicle_mileage} kms`
          });
        }
      });
    }
    return data;
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const {
      item_type,
      location_id_1,
      location_id_2,
      transfer_date,
      setup_date
    } = this.props.formData;
    if (item_type !== prevProps.formData.item_type) {
      this.getDataFor(
        item_type,
        location_id_1,
        location_id_2,
        transfer_date,
        setup_date
      ).then(dataItems => {
        const data = { data: dataItems };
        this.setState(data);
      });
    }
  }

  async componentDidMount() {
    let defaultItemType = "glove";

    if (this.props.formData.item_type) {
      defaultItemType = this.props.formData.item_type;
    }

    const {
      location_id_1,
      location_id_2,
      transfer_date,
      setup_date
    } = this.props.formData;
    const dataItems = await this.getDataFor(
      defaultItemType,
      location_id_1,
      location_id_2,
      transfer_date,
      setup_date
    );
    const data = { data: dataItems };
    this.setState(data);
  }
  render() {
    return (
      <div>
        <span>
          <AutocompleteInput
            source="item_id"
            choices={this.state.data}
            {...this.rest}
            optionText="description"
            optionValue="id"
          />
        </span>
      </div>
    );
  }
}

const ItemEditToolbar = (props, classes, className) => {
  return (
    <Toolbar {...props}>
      <SaveButton redirect={true} />
      <Button
        component={Link}
        to={{
          pathname: `${props.redirect}`
        }}
        label="Cancel"
      >
        <ArrowBackIcon />
      </Button>
    </Toolbar>
  );
};

const EditTransferIItemTitle = () => <span>Edit Transfer Item</span>;

const CreateTransferIItemTitle = record => (
  <span>{"Create transfer item"}</span>
);

const itemTypes = [
  // { _id: "glove", description: "Glove" },
  // { _id: "helmet", description: "Helmet" },
  // { _id: "jacket", description: "Jacket" },
  // { _id: "seat", description: "Seat" },
  // { _id: "tankbag", description: "Tankbag" },
  { _id: "gps_device", description: "Gps" },
  { _id: "vehicle", description: "Vehicle" }
];

export const TransferItemEdit = props => {
  const transfer_id = parse(props.location.search).transfer_id;
  const redirect = transfer_id ? `/transfers/${transfer_id}` : "edit";

  return (
    <Edit title={<EditTransferIItemTitle />} {...props}>
      <SimpleForm
        redirect={redirect}
        toolbar={<ItemEditToolbar props={{ ...props }} />}
      >
        <DisabledInput label="Id" source="transfer_id" />
        <SelectInput
          source="item_type"
          choices={itemTypes}
          optionText="description"
          optionValue="_id"
        />
        <FormDataConsumer>
          {({ formData, ...rest }) => (
            <AsyncComponent formData={formData} rest={rest} />
          )}
        </FormDataConsumer>
      </SimpleForm>
    </Edit>
  );
};

export const TransferItemCreate = props => {
  const transfer_id = parse(props.location.search).transfer_id;
  const redirect = transfer_id ? `/transfers/${transfer_id}` : "edit";

  return (
    <Create title={<CreateTransferIItemTitle />} {...props}>
      <SimpleForm redirect={redirect}>
        <DisabledInput label="Id" source="transfer_id" />
        <SelectInput
          source="item_type"
          choices={itemTypes}
          optionText="description"
          optionValue="_id"
        />
        <FormDataConsumer>
          {({ formData, ...rest }) => (
            <AsyncComponent formData={formData} rest={rest} />
          )}
        </FormDataConsumer>
      </SimpleForm>
    </Create>
  );
};



// WEBPACK FOOTER //
// ./src/resources/transferItems.js